/* eslint-disable react-hooks/rules-of-hooks */
import Add from "@mui/icons-material/Add";
import ArrowBack from "@mui/icons-material/ArrowBack";
import DeleteOutlined from "@mui/icons-material/DeleteOutlined";
import Inventory2Rounded from "@mui/icons-material/Inventory2TwoTone";
import PhotoLibraryOutlined from "@mui/icons-material/PhotoLibraryOutlined";
import SlideshowOutlined from "@mui/icons-material/SlideshowOutlined";
import { Avatar, Box, Button, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Skeleton, Typography } from "@mui/material";
import { Fragment, useState } from "react";
import { useMiddleware } from "../../../Application";
import { useAuth } from "../../../auth";
import ResponsiveDialog from "../../../components/ResponsiveDialog";
import useDialogProps from "../../../utils/useDialogProps";
import FileSelectDialog from "../components/FileSelectDialog";
import { v4 as uuidv4 } from "uuid";
import Lightbox from 'react-image-lightbox';
import { Icon as Iconify } from "@iconify/react";

import 'react-image-lightbox/style.css';

import 'swiper/css';


const ProductMediaDialog = ({ open, onClose, defaultValue = [], onConfirm }) => {

    const middleware = useMiddleware('Storage.Main');
    const { workspace, getAuthToken } = useAuth();

    const [value, setValue] = useState(defaultValue);

    const [fileSelectDialogProps, setFileSelectDialogProps] = useState({ open: false });


    return (
        <ResponsiveDialog
            open={open}
            onClose={onClose}
            dialogProps={{
                fullWidth: true,
                maxWidth: "xs"
            }}
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>مدیریت رسانه‌ها</Box>
                <IconButton onClick={onClose} size="small">
                    <ArrowBack />
                </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ p: 0 }}>
                <List disablePadding dense>
                    <ListItem disablePadding dense>
                        <ListItemButton
                            onClick={() => setFileSelectDialogProps({
                                open: true,
                                selected: value.filter(m => m.intro)[0]?.file,
                                onClear: () => setValue(value.filter(m => !m.intro)),
                                onSelect: file => setValue([...value.filter(m => !m.intro), { file, intro: true }])
                            })}
                        >
                            <ListItemIcon>
                                <SlideshowOutlined />
                            </ListItemIcon>
                            <ListItemText
                                primary={<small>برای انتخاب کلیک کنید</small>}
                                secondary="ویدئو معرفی"
                            />
                        </ListItemButton>
                    </ListItem>
                </List>
                <Divider />
                <Box sx={{ p: 2 }}>
                    <Typography fontWeight={700} sx={{ mb: 2 }}>تصاویر</Typography>
                    <Grid container spacing={1}>
                        {value.filter(m => !m.intro).map((media, idx) => (
                            <Grid item xs="auto" key={idx}>
                                <Box sx={theme => ({ position: 'relative', borderRadius: theme.shape.borderRadius, overflow: 'hidden' })}>
                                    <Avatar
                                        key={idx}
                                        src={middleware.getDirectDownloadUrl(media.file.id, getAuthToken(), workspace.id)}
                                        sx={{ width: 64, height: 64 }}
                                        variant="rounded"
                                    />
                                    <Box
                                        sx={theme => ({
                                            position: 'absolute',
                                            left: 0,
                                            top: 0,
                                            width: '100%',
                                            height: '100%',
                                            background: 'rgba(0,0,0,0.5)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#fff',
                                            opacity: 0,
                                            transition: theme.transitions.create('opacity'),
                                            cursor: 'pointer',
                                            '&:hover': {
                                                opacity: 1
                                            }
                                        })}
                                        onClick={() => setValue(value.filter(m => m.file.id !== media.file.id))}
                                    >
                                        <DeleteOutlined fontSize="large" />
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                        <Grid item xs={6} sm={4} md={3}>
                            <Avatar
                                sx={theme => ({
                                    position: 'relative',
                                    width: 64,
                                    height: 64,
                                    background: 'transparent',
                                    border: '1px dashed',
                                    borderColor: 'divider',
                                    color: 'divider',
                                    cursor: 'pointer',
                                    transition: theme.transitions.create('all'),
                                    '&:hover': {
                                        borderStyle: 'solid',
                                    }
                                })}
                                variant="rounded"
                                onClick={() => setFileSelectDialogProps({
                                    open: true,
                                    multiple: true,
                                    selected: value.filter(m => !m.intro).map(m => m.file),
                                    // onClear: () => setValue(value.filter(m => !m.intro)),
                                    onSelect: file => setValue(
                                        value.filter(c => c.file.id === file.id).length > 0 ?
                                            value.filter(c => c.file.id !== file.id) :
                                            [...value, { file }]
                                    )
                                })}
                            >
                                <Add />
                            </Avatar>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
            <Divider />
            <DialogActions>
                {onConfirm && (
                    <Button
                        type="button"
                        variant="contained"
                        onClick={() => onConfirm(value)}
                    >
                        تایید و بستن
                    </Button>
                )}
                <Box sx={{ flexGrow: 1 }}></Box>
                <Button type="button" onClick={onClose}>بستن</Button>
            </DialogActions>

            <FileSelectDialog
                {...fileSelectDialogProps}
                onClose={() => setFileSelectDialogProps({ open: false })}
                selectable
            // multiple
            // selected={value}
            // onClear={() => setValue([])}
            // onSelect={file => setValue(
            //     value.filter(c => c.id === file.id).length > 0 ?
            //         value.filter(c => c.id !== file.id) :
            //         [...value, file]
            // )}
            />

        </ResponsiveDialog>
    )
}

const ProductDetailsOverview = ({ product, loading }) => {
    const { getAuthToken, workspace } = useAuth();
    const middleware = useMiddleware('Storage.Main');

    const handleView = async (file) => {
        const fileMediaIndex = product.media.findIndex(media => media.file.id === file.id);
        setLightBoxProps({
            open: true,
            mainSrc: middleware.getDirectDownloadUrl(file.id, getAuthToken(), workspace.id),
            ...((product.media.length > 1 && fileMediaIndex > 0) && {
                prevSrc: middleware.getDirectDownloadUrl(product.media[fileMediaIndex - 1].file.id, getAuthToken(), workspace.id)
            }),
            ...((product.media.length > 1 && fileMediaIndex < product.media.length) && {
                nextSrc: middleware.getDirectDownloadUrl(product.media[fileMediaIndex + 1].file.id, getAuthToken(), workspace.id)
            }),
        })
    }
    const [lightBoxProps, setLightBoxProps] = useState({ open: false });


    return (
        <Box sx={{ p: { xs: 2, sm: 3, md: 4 } }} key={uuidv4()}>
            <Typography variant="h6" sx={{ mb: 3 }}>تصاویر و ویدئو</Typography>
            <Grid container spacing={1}>
                {product.media && product.media.map((media, idx) => (
                    <Grid item xs='auto' key={idx}>
                        <Avatar
                            key={idx}
                            src={middleware.getDirectDownloadUrl(media.file.id, getAuthToken(), workspace.id)}
                            sx={{ width: 64, height: 64, cursor: 'pointer' }}
                            variant="rounded"
                            onClick={() => handleView(media.file)}
                        />
                    </Grid>
                ))}
            </Grid>

            {lightBoxProps.open && (
                <Lightbox
                    {...lightBoxProps}
                    // mainSrc={images[photoIndex]}
                    // nextSrc={images[(photoIndex + 1) % images.length]}
                    // prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                    onCloseRequest={() => setLightBoxProps({ open: false })}
                    reactModalStyle={{ overlay: { zIndex: 10000 }, content: { direction: 'ltr' } }}
                // reactModalStyle={{
                //     zIndex: 100000
                // }}
                // onMovePrevRequest={() =>
                //     this.setState({
                //         photoIndex: (photoIndex + images.length - 1) % images.length,
                //     })
                // }
                // onMoveNextRequest={() =>
                //     this.setState({
                //         photoIndex: (photoIndex + 1) % images.length,
                //     })
                // }
                />
            )}
        </Box>
    )
}

const products = {
    'ProductsList.definitions': () => {
        const { getAuthToken, workspace } = useAuth();
        const middleware = useMiddleware('Storage.Main');

        return ({
            title: 'تصویر',
            render: row => (
                <Avatar
                    variant="rounded"
                    alt={row?.name}
                    src={row?.thumbnail ? middleware.getDirectDownloadUrl(row.thumbnail.id, getAuthToken(), workspace.id) : null}
                    sx={{ width: 48, height: 48 }}
                    
                >
                    <Iconify icon='solar:box-bold-duotone'/>
                </Avatar>
            ),
            priority: 250,
        });
    },
    'ProductDetails.TabView': ({ loading, product }) => {
        const { getAuthToken, workspace } = useAuth();
        const middleware = useMiddleware('Storage.Main');
        
        return ({
            renderIcon: ({ sx, props }) => (
                <Avatar
                    {...props}
                    variant="rounded"
                    alt={product?.name}
                    src={product?.media && product?.media.length > 0 ? middleware.getDirectDownloadUrl(product?.media[0].file.id, getAuthToken(), workspace.id) : null}
                    sx={{ ...sx, width: 30, height: 30 }}
                >
                    <Iconify {...props} icon='solar:box-bold-duotone'/>
                </Avatar>
            ),
        })
    },
    'ProductDetails.Overview.Grid': injectedParams => (<ProductDetailsOverview {...injectedParams} />),
    'ProductDetails.PreHeader': ({ loading, product }) => {

        const middleware = useMiddleware('Storage.Main');
        const { getAuthToken, workspace } = useAuth();


        return loading ? (
            <Skeleton
                width={50}
                height={50}
                variant="rectangular"
                sx={{ mr: 2 }}
                key={uuidv4()}
            />
        ) : (
            <Avatar
                src={product.thumbnail && middleware.getDirectDownloadUrl(product.thumbnail.id, getAuthToken(), workspace.id)}
                variant="rounded"
                sx={{ mr: 2, width: 64, height: 64 }}
                key={uuidv4()}
            >
                <Inventory2Rounded fontSize="large" />
            </Avatar>
        )
    },
    'ProductForm.initialValues': () => ({
        media: []
    }),
    'ProductForm.Hooks': injectedParams => ({
        'mediaDialogHook': useDialogProps(),
    }),
    'ProductForm.PostForm': ({ mediaDialogHook, key }) => {
        const [mediaDialogProps, openMediaDialog, closeMediaDialog] = mediaDialogHook;


        return (
            <Box key={key}>
                <Divider />
                <List disablePadding dense>
                    <ListItem disablePadding dense>
                        <ListItemButton onClick={() => openMediaDialog()}>
                            <ListItemIcon>
                                <PhotoLibraryOutlined />
                            </ListItemIcon>
                            <ListItemText
                                primary={<small>برای انتخاب کلیک کنید</small>}
                                secondary="رسانه‌ها"
                            />
                        </ListItemButton>
                    </ListItem>
                </List>
            </Box>
        )
    },
    'ProductForm.Footer': ({ getValue, setValue, mediaDialogHook, key }) => {
        const [mediaDialogProps, openMediaDialog, closeMediaDialog] = mediaDialogHook;

        return (
            <Fragment key={key}>
                <ProductMediaDialog
                    defaultValue={getValue('media')}
                    onConfirm={media => {
                        setValue('media', media);
                        closeMediaDialog();
                    }}
                    {...mediaDialogProps}
                />
            </Fragment>
        )
    },
}

export default products;